export default "ewogICAgICAgICJpbnRybzE1IiA6IHsKICAgICAgICAgICAgInRvdGFsUGVyY2VudGFnZSIgOiAxNQogICAgICAgIH0KICAgIH0=";